import Styled, { css } from 'styled-components';

import { cssDeclaration } from '../Utils';

import { StyledFooterLink } from './Link/StyledFooterLink';

export const StyledFooterList = Styled.ul`
  display: flex;

  ${({ theme: { themeTwo }}) => {
    const { layout: { footer } } = themeTwo;

    return css`
      /* margin-top */ ${cssDeclaration(themeTwo, 'margin', footer.margin)}

      & > li:not(:last-of-type) > ${StyledFooterLink} {
       /* margin-right */ ${cssDeclaration(themeTwo, 'margin', footer.link.margin)};
      }
    `;
  }}
`;
